import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  UseCandidateMessageReturnType,
  useCandidateMessageInternal,
} from 'hooks/useCandidateMessage/useCandidateMessageInternal';
import { TouchpointAttributes } from 'lib/models/message';

const initialContext: UseCandidateMessageReturnType = {
  isRoomsFetching: false,
  isLoading: false,
  isMessagesFetching: false,
  rooms: [],
  onMuteConversation: () => new Promise(noop),
  onDeleteConversation: () => new Promise(noop),
  onBlockConversation: () => new Promise(noop),
  fetchRoomMessages: () => new Promise(noop),
  sendMessage: () => new Promise(noop),
  getParticipants: () => new Promise(noop),
  touchpointCachedData: {},
  fetchTouchpointData: () => new Promise(noop),
  getTouchpointData: function (): Promise<void | TouchpointAttributes> {
    throw new Error('Function not implemented.');
  },
  activeRoom: null,
  showParticipantsModal: false,
  setShowParticipantsModal: () => {},
  onRoomSelect: () => () => {},
  onClearActiveRoom: () => {},
  toggleParticipantsModal: () => {},
  interactedSocieties: [],
  isInteractedSocietiesLoading: false,
  selectedInteractedSociety: null,
  onSelectInteractedSociety: () => {},
  onClearSelectedInteractedSociety: () => {},
  onUpdateLastPost: () => {},
  onReadPost: () => {},
  totalUnreadPostCount: 0,
};

const CandidateMessageContext =
  createContext<UseCandidateMessageReturnType>(initialContext);

export const useCandidateMessage = () => useContext(CandidateMessageContext);

export const CandidateMessageProvider: React.FC = ({ children }) => {
  const value = useCandidateMessageInternal();

  return (
    <CandidateMessageContext.Provider value={value}>
      {children}
    </CandidateMessageContext.Provider>
  );
};
